import { V2Purpose } from "src/pages/reports/fsci/v2/types";

export const meta: Record<V2Purpose, Opportunity> = {
    godsStory: {
        title: "God's Story",
        prologue:
            "Students believe they are a part of God’s bigger plan and can be used by him to “make a difference.”",
    },
    holisticTeaching: {
        title: "Holistic Teaching",
        prologue:
            "Teaching involves helping students develop spiritually and emotionally (teaching the heart and soul, as well as the mind).",
    },
    integratedWorldView: {
        title: "Integrated Worldview",
        prologue: "Christian worldview changes how we educate; there is no such thing as a secular sphere.",
    },
    partnership: {
        title: "Partnership",
        prologue:
            "Families feel they are a part of the school’s mission, and that their child’s spiritual development requires their partnering with and being involved at the school.",
    },
    questioning: {
        title: "Questioning",
        prologue:
            "Students have doubts about their faith, lack time to pray or study the Bible, and feel that most Christians are too judgmental.",
        extra: "* The higher the score on this construct, the more respondents disagreed with the construct’s items. Thus, in general, a higher score would mean that fewer respondents had doubts about their faith, lacked time to pray or study the Bible, and/or felt that most Christians are too judgmental. However, schools should consider this specific construct of Questioning in light of their mission and vision for faith formation and discipleship; in other words, student questioning may not be viewed as something problematic to be “solved,” but rather as an opportunity to meaningfully engage students in mentorship, discussion, and other life-on-life discipleship efforts.",
    },
    responsibility: {
        title: "Responsibility",
        prologue:
            "Leaders, teachers, and support staff feel a sense of shared ownership for school mission, success, and improvement.",
    },
    spiritualFormation: {
        title: "Spiritual Formation",
        prologue:
            "Alumni report that their Christian faith is stronger thanks to attending a Christian school, and they believe people can change with God’s help.",
    },
};
